<template>
<div>

    <router-view/>

</div>
    

</template>

<script>


export default {
  name: 'App',
  components: {

  }
}
</script>

<style>

@import './styles/style.css';


</style>
